<template>
  <v-dialog
    v-model="isOpen"
    width="450"
    scrollable
    :persistent="loading"
    @click:outside="close"
  >
    <v-card>
      <template v-if="!success">
        <v-card-title class="text-h6"> Adicionar chave </v-card-title>

        <v-card-text class="pa-4 pt-1" v-if="!success">
          <v-form @submit.prevent v-model="valid">
            <v-text-field
              v-model="apiKey.name"
              label="Nome da chave"
              outlined
              :disabled="loading"
              :rules="[(v) => !!v || 'Nome da chave é obrigatório']"
            />
            <PlatformSelector
              label="Plataforma"
              v-model="apiKey.platform"
              class="mb-6"
              clearable
              placeholder="Deixe em branco para todas as plataformas"
              :dense="false"
              :disabled="loading"
            />
            <v-text-field
              v-model="apiKey.expiresAt"
              label="Expira em"
              type="date"
              hint="Deixe em branco para nunca expirar"
              clearable
              outlined
              :min="new Date().toISOString().split('T')[0]"
              :disabled="loading"
            />
          </v-form>
          <v-alert v-if="!!error" outlined text color="error">
            {{ error }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-btn text :disabled="loading" @click="close"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="loading || !valid"
            :loading="loading"
            @click="save"
          >
            Criar
          </v-btn>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-title class="text-h6"> Chave criada com sucesso </v-card-title>
        <v-card-text class="pa-4 pt-1">
          <v-text-field
            :value="success.apiKey.key"
            label="Chave"
            outlined
            readonly
            @click="copyKey"
            @click:append="copyKey"
            :append-icon="successCopied ? 'mdi-check' : 'mdi-content-copy'"
            :color="successCopied ? 'success' : 'primary'"
          />
          <v-alert text color="warning">
            Atenção! Não será possível visualizar a chave novamente. Guarde-a em
            um local seguro.
          </v-alert>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text :disabled="loading" @click="close"> Fechar </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import API_KEYS from "@/services/admin/apiKeys";
import PlatformSelector from "@/components/global/PlatformSelector.vue";

const defaultApiKey = () => ({
  expiresAt: null,
  platform: null,
});
export default {
  components: {
    PlatformSelector,
  },
  data: () => ({
    isOpen: false,
    loading: false,
    valid: false,
    error: false,
    apiKey: defaultApiKey(),
    success: false,
    successCopied: false,
  }),

  methods: {
    open(data = {}) {
      this.isOpen = true;
      this.success = false;
      this.apiKey = Object.assign(defaultApiKey(), data);
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    close() {
      if (this.loading) return;
      this.isOpen = false;
      this.loading = false;
      this.error = false;
      this.apiKey = defaultApiKey();
    },

    async save() {
      try {
        this.loading = true;
        this.error = false;
        const response = await API_KEYS.create({
          name: this.apiKey.name,
          platformId: this.apiKey.platform?.id || null,
          expiresAt: this.apiKey.expiresAt
            ? new Date(this.apiKey.expiresAt)
            : null,
        });
        this.success = response;
        this.loading = false;
        this.$emit("success", response);
      } catch (e) {
        this.error = e.message;
        this.loading = false;
      }
    },
    copyKey() {
      navigator.clipboard.writeText(this.success.apiKey.key);
      this.successCopied = true;
      setTimeout(() => {
        this.successCopied = false;
      }, 2000);
    },
  },

  mounted() {
    this.$root.$on("api-key-modal", this.open);
  },
};
</script>

<style></style>
